export default {
  sections: {
    requiredQualification: {
      title: 'Qualifications requises',
      description: 'Pour chaque représentant légal présent, la qualification en termes de connaissance et d\'expérience (QCE) sur les produits et services financiers doit être à jour',
      subtitle: 'Actions nécessaires de votre part',
      legalRepresentativeTitle: 'Connaissance et expérience des représentants légaux',
      minorTitle: 'Sensibilité extra-financière de l\'enfant mineur',
      toUpdate: 'Mettre à jour',
      toModify: 'Modifier',
      infoMessage: `<b>En savoir plus</b>: Le profil investisseur retenu est « Sécuritaire
          » par défaut. Ce profil peut être modifié ultérieurement pour ce
          conseil.<br /><br />
          Le niveau de connaissance et expérience retenu est :
          <ul>
            <li>
              - celui du moins sachant dans le cas de l&apos;administration
              légale conjointe et lorsque les deux représentants légaux sont
              présents ;
            </li>
            <li>
              - débutant (A) dans le cas de l&apos;administration légale
              conjointe et lorsque un des deux représentants légaux est absent ;
            </li>
            <li>
              - celui du représentant légal dans le cas de l’administration
              légale unique.
            </li>
          </ul>`
    },
  },
}
